<script>

export default {
  methods: {},
  props: {
    options: [Array, Object],
    selected: [Array, Object],
    disabled: Boolean,
    focus: String,
    blur: String,
    optional: Boolean,
    unselectLabel: String,
    multipleSelection: {
      type: Boolean,
      default: false,
    },
    listHeight: {
      type: String,
      default: "280",
    },
    autoscroll: Function,
    change: Function,
    error: Boolean,
    pending: Boolean,
    order: {
      type: String,
      default: "ASC",
    },
    filterEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      focused: false,
      active: false,
      opened: false,
      current: null,
      width: 0,
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      height: 0,
      filterTerm: "",
    };
  },
  computed: {
    cssVars() {
      return {
        "--height": this.height,
        "--width": this.width,
        "--left": this.left,
        "--top": this.top,
        "--right": this.right,
        "--bottom": this.bottom,
      };
    },
    orderOptions() {
      return Object.values(this.options).sort((a, b) => {
        if (this.order == "ASC") {
          return a.weight - b.weight;
        } else if (this.order == "DSC") {
          return b.weight - a.weight;
        }
      });
    },
    filteredOptions() {
      if (!this.filterTerm) {
        return this.orderOptions;
      }
      const term = this.filterTerm.toString().toLowerCase().trim();
      return this.orderOptions.filter((option) => {
        const title = (option && option.title != null) ? this.$vt(option.title).toString() : "";
        return title.toLowerCase().includes(term);
      });
    }
  },
  methods: {
    open: function ($event) {
      if (this.opened) {
        this.opened = false;
        return;
      }
      this.positionOptions();
      this.opened = true;
      setTimeout(() => {
        if(this.$refs.filterInput) {
          this.$refs.filterInput.focus();
        }
      });
    },
    positionOptions: function () {
      var space = 8;

      let $el = $(this.$el).find(".f-select");

      let offset = $el.offset();

      const boundingRect = $el[0].getBoundingClientRect();
      const clientWidth = $el[0].clientWidth;

      const zoom = Math.round((100 * clientWidth) / boundingRect.width) / 100;

      let rect;
      if (zoom !== 1) {
        rect = {
          top: boundingRect.top * zoom,
          left: boundingRect.left * zoom,
          width: boundingRect.width * zoom,
          height: boundingRect.height * zoom,
          bottom: boundingRect.bottom * zoom,
          right: boundingRect.right * zoom,
        };
      } else {
        rect = boundingRect;
      }

      this.top = "auto";
      this.left = rect.left + "px";
      this.bottom = "auto";
      this.right = "auto";
      this.width = $el.width() + "px";

      this.height = this._props.listHeight + "px";

      const zoomedListHeight = Math.round(this.listHeight / zoom);

      // Si y'a la place dessous l'input
      if (window.innerHeight - boundingRect.bottom > zoomedListHeight + space) {
        this.top = `${rect.top + rect.height + space}px`;
      }
      // Si y'a la place au dessus de l'input
      else if (boundingRect.top > zoomedListHeight + space) {
        this.bottom = `${window.innerHeight * zoom - rect.top + space}px`;
      }
      // Sinon bah on prend toute la hauteur
      else {
        this.height = "auto";
        this.top = 0;
        this.bottom = 0;
      }
    },
    close: function () {
      this.opened = false;
    },
    scroll: function ($event) {
      const tolerance = 20;
      if (
        $event.srcElement.scrollTop + tolerance >
        $event.srcElement.scrollHeight - $event.srcElement.offsetHeight
      ) {
        this.$emit("autoscroll", true);
      } else {
        this.$emit("autoscroll", false);
      }
    },
    optionsClick: function (option) {
      if (this.multipleSelection) {
        if (this.current[option.key]) {
          this.$delete(this.current, option.key);
        }
        else {
          this.$set(this.current, option.key, option);
        }
        this.$emit('change', option);
        this.$emit('update:selected', option);

      }
      else {
        this.opened = false;
        this.current = option;
        this.$emit('change', option);
        this.$emit('update:selected', option);
      }
    },
    isSelected(option) {
      if (this.multipleSelection) {
        return this.current[option.key];
      }
      else {
        return this.current == option;
      }
    }
  },
  mounted: function () {
    this.current = this.selected;
    window.addEventListener("resize", this.positionOptions);
  },
  destroyed() {
    window.addEventListener("resize", this.positionOptions);
  },
  watch: {
    selected: function (v) {
      this.current = this.selected;
    },
  },
};
</script>

<template>
  <f-field :optional="optional" :focused="focused" :active="active" :class="{ opened: opened, error: error, disabled: disabled }">
    <template v-slot:label>
      <slot name="label"></slot>
    </template>
    <template v-slot:content>
      <div class="f-select" :class="{ error, disabled}">
        <div class="current" @mousedown="active = true" @mouseup="active = false" @mouseover="focused = true"
          @mouseleave="focused = false" @click.stop="open($event)">
          <div v-if="current">{{ $vt(current.title) }}</div>
          <div v-if="multipleSelection && current" class="multiple-selection-currents">
            <span v-for="c in current" class="multiple-selection-current" @click.stop="optionsClick(c)">
              {{ c.title }}
              <f-icon icon="fa6-times"></f-icon>
            </span>
          </div>
          <div class="icon">
            <f-icon icon="fa6-angle-down"></f-icon>
          </div>
        </div>
        <div class="options-modal" v-if="opened" @wheel="close($event)">
          <div class="options-container" :style="cssVars" v-click-outside="close" @wheel.stop>
            <div class="filter" v-if="filterEnabled" @click.stop>
              <input ref="filterInput" type="text" v-model="filterTerm" :placeholder="$vt('Search')" />
            </div>
            <div class="options" @scroll="scroll($event)">
              <div class="option" v-if="unselectLabel" @click="
                optionsClick(null, $event)
                ">
                {{ $vt(unselectLabel) }}
              </div>
              <div class="option" :class="{ selected: isSelected(option) }" :value="option.key" :key="option.key"
                v-for="option in filteredOptions" @click="
                  optionsClick(option)
                  ">
                <f-icon class="selected-icon" icon="fa6-check"></f-icon>{{ $vt(option.title) }}
              </div>
              <div class="option pending" v-if="pending">
                <f-icon spin icon="fa6-circle-notch"></f-icon>
              </div>
              <div class="option empty" v-if="unselectLabel == null && filteredOptions.length == 0">
                {{ $vt("Empty") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:helper>
      <slot name="helper"></slot>
    </template>
  </f-field>
</template>

<style lang="scss">
.f-field {
  .f-select {
    &.error {
      .current {
        border: 1px solid var(--statusNegative);
      }
    }

    &.disabled {
      opacity: 0.6;
      pointer-events: none;
    }

    cursor: pointer;

    .current {
      position: relative;
      font-family: Raleway;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #161615;
      padding: 10px 12px;
      background: rgba(239, 239, 238, 0.5);
      border-radius: 6px;
      border: 1px solid transparent;
      width: 100%;
      min-height: 50px;
      display: flex;
      align-items: center;
      border: 1px solid #bbbbb8;

      .multiple-selection-currents {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .multiple-selection-current {
          display: flex;
          align-items: center;
          gap: 10px;
          background: var(--white-a10);
          padding: 5px;
          border-radius: 4px;

          &:hover {
            background: var(--white-a25);
          }
        }
      }

      &:hover {
        border: 1px solid rgba(24, 144, 211, 0.75);
      }

      .icon {
        position: absolute;
        right: 4px;
        top: 4px;
        bottom: 4px;
        color: #161615;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        border-radius: 4px;
      }
    }

    .options-modal {
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;
    }

    .options-container {
      display: flex;
      flex-direction: column;
      z-index: 1;
      background-color: white;
      box-shadow: 0px 8px 32px -8px rgba(22, 22, 21, 0.25);
      border-radius: 8px;
      padding: 8px;
      position: fixed;
      box-sizing: border-box;
      max-height: var(--height);
      left: var(--left);
      top: var(--top);
      right: var(--right);
      bottom: var(--bottom);
      width: var(--width);
    }

    .filter {
      position: sticky;
      top: 0;
      background: inherit;
      padding: 8px 8px 0 8px;
      z-index: 2;

      input {
        width: 100%;
        box-sizing: border-box;
        padding: 10px 12px;
        font-size: 14px;
        line-height: 20px;
        border: 1px solid var(--white-a25);
        border-radius: 6px;
        background: none;
        color: var(--white-a50);
        ;
      }
    }

    .options {
      flex-direction: column;
      overflow: auto;
      width: 100%;
      margin-top: 8px;



      &::-webkit-scrollbar {
        width: 8px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-track:hover {
        background: transparent;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: var(--white-a25);
        border-radius: 8px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: var(--white-a25);
        border-radius: 8px;
      }

      .option {
        font-family: Lato;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: #161615;
        padding: 16px 0;
        display: flex;
        padding-left: 40px;
        position: relative;

        &.pending {
          display: flex;
          justify-content: center;
          align-items: center;
          padding-right: 40px;
        }

        &.empty {
          opacity: 0.5;
          cursor: default;

          &:hover {
            background: transparent;
          }
        }

        .selected-icon {
          display: none;
          position: absolute;
          left: 0;
          top: 0;
          width: 40px;
          height: 100%;
          align-items: center;
          justify-content: center;
        }

        &:hover {
          background: rgba(24, 144, 211, 0.1);
        }

        &.selected {
          .selected-icon {
            display: flex;
          }
        }
      }
    }
  }

  &.focused {
    .current {
      border: 1px solid #1890d3;
      outline: 5px solid rgba(24, 144, 211, 0.25);

      .icon {
        background-color: rgba(24, 144, 211, 0.1);
      }
    }
  }

  &.active {
    .current {
      .icon {
        background: rgba(24, 144, 211, 0.25);
      }
    }
  }
}

.dark-mode {
  .f-field {
    .f-select {
      &.error {
        .current {
          border: 1px solid var(--negative);
        }
      }

      .current {
        color: var(--white-a50);
        background: transparent;
        border: 1px solid var(--white-a25);

        &:hover {
          border: 1px solid var(--navigation-a50);
        }

        .icon {
          color: var(--white-a75);
        }
      }

      .options-container {
        background-color: #000;
        box-shadow: 0 12px 24px var(--white-a5);
      }

      .options {

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: var(--white-a25);
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: var(--white-a25);
        }

        .option {
          color: var(--white-a50);

          &.empty {
            &:hover {
              background: transparent;
            }
          }

          &:hover {
            background: var(--navigation-a25);
          }
        }
      }
    }

    &.focused,
    &.opened {
      .current {
        border: 1px solid var(--navigation);
        outline: 5px solid var(--navigation-a25);

        .icon {
          background-color: var(--navigation);
          color: var(--black);
        }
      }
    }
  }
}
</style>